// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
	/* #region black */

	--palette-black-h: 0;
	--palette-black-s: 0%;
	--palette-black-l: 0%;
	--palette-black-a: 1;

	--palette-black-0: hsl(
		var(--palette-black-h),
		var(--palette-black-s),
		var(--palette-black-l),
		var(--palette-black-a)
	);

	/* ten shades of black */

	--palette-black-10: hsla(
		var(--palette-black-h),
		var(--palette-black-s),
		var(--palette-black-l),
		calc(var(--palette-black-a) - 0.1)
	);

	--palette-black-20: hsla(
		var(--palette-black-h),
		var(--palette-black-s),
		var(--palette-black-l),
		calc(var(--palette-black-a) - 0.2)
	);

	--palette-black-30: hsla(
		var(--palette-black-h),
		var(--palette-black-s),
		var(--palette-black-l),
		calc(var(--palette-black-a) - 0.3)
	);
	--palette-black-40: hsla(
		var(--palette-black-h),
		var(--palette-black-s),
		var(--palette-black-l),
		calc(var(--palette-black-a) - 0.4)
	);
	--palette-black-50: hsla(
		var(--palette-black-h),
		var(--palette-black-s),
		var(--palette-black-l),
		calc(var(--palette-black-a) - 0.5)
	);
	--palette-black-60: hsla(
		var(--palette-black-h),
		var(--palette-black-s),
		var(--palette-black-l),
		calc(var(--palette-black-a) - 0.6)
	);
	--palette-black-70: hsla(
		var(--palette-black-h),
		var(--palette-black-s),
		var(--palette-black-l),
		calc(var(--palette-black-a) - 0.7)
	);
	--palette-black-80: hsla(
		var(--palette-black-h),
		var(--palette-black-s),
		var(--palette-black-l),
		calc(var(--palette-black-a) - 0.9)
	);
	--palette-black-90: hsla(
		var(--palette-black-h),
		var(--palette-black-s),
		var(--palette-black-l),
		calc(var(--palette-black-a) - 0.95)
	);
	--palette-black-100: hsla(
		var(--palette-black-h),
		var(--palette-black-s),
		var(--palette-black-l),
		calc(var(--palette-black-a) - 1)
	);

	/* #endregion */

	/* #region white */

	--palette-white-h: 0;
	--palette-white-s: 0%;
	--palette-white-l: 100%;
	--palette-white-a: 1;

	--palette-white-0: hsla(
		var(--palette-white-h),
		var(--palette-white-s),
		var(--palette-white-l),
		var(--palette-white-a)
	);

	/*  10 tints of white */

	--palette-white-10: hsla(
		var(--palette-grey-h),
		var(--palette-grey-s),
		var(--palette-grey-l),
		calc(var(--palette-grey-a) - 0.1)
	);

	--palette-white-20: hsla(
		var(--palette-grey-h),
		var(--palette-grey-s),
		var(--palette-grey-l),
		calc(var(--palette-grey-a) - 0.2)
	);

	--palette-white-30: hsla(
		var(--palette-grey-h),
		var(--palette-grey-s),
		var(--palette-grey-l),
		calc(var(--palette-grey-a) - 0.3)
	);
	--palette-white-40: hsla(
		var(--palette-grey-h),
		var(--palette-grey-s),
		var(--palette-grey-l),
		calc(var(--palette-grey-a) - 0.4)
	);
	--palette-white-50: hsla(
		var(--palette-grey-h),
		var(--palette-grey-s),
		var(--palette-grey-l),
		calc(var(--palette-grey-a) - 0.5)
	);
	--palette-white-60: hsla(
		var(--palette-grey-h),
		var(--palette-grey-s),
		var(--palette-grey-l),
		calc(var(--palette-grey-a) - 0.6)
	);
	--palette-white-70: hsla(
		var(--palette-grey-h),
		var(--palette-grey-s),
		var(--palette-grey-l),
		calc(var(--palette-grey-a) - 0.7)
	);
	--palette-white-80: hsla(
		var(--palette-grey-h),
		var(--palette-grey-s),
		var(--palette-grey-l),
		calc(var(--palette-grey-a) - 0.9)
	);
	--palette-white-90: hsla(
		var(--palette-grey-h),
		var(--palette-grey-s),
		var(--palette-grey-l),
		calc(var(--palette-grey-a) - 0.95)
	);
	--palette-white-100: hsla(
		var(--palette-grey-h),
		var(--palette-grey-s),
		var(--palette-grey-l),
		calc(var(--palette-grey-a) - 1)
	);

	/* #endregion */

	/* #region grey */

	--palette-grey-h: 210;
	--palette-grey-s: 20%;
	--palette-grey-l: 8%;
	--palette-grey-a: 1;

	--palette-grey-0: hsl(
		var(--palette-grey-h),
		var(--palette-grey-s),
		var(--palette-grey-l)
	);
	--palette-grey-10: hsl(
		var(--palette-grey-h),
		var(--palette-grey-s),
		calc(var(--palette-grey-l) + 4%)
	);
	--palette-grey-20: hsl(
		var(--palette-grey-h),
		var(--palette-grey-s),
		calc(var(--palette-grey-l) + 8%)
	);
	--palette-grey-30: hsl(
		var(--palette-grey-h),
		var(--palette-grey-s),
		calc(var(--palette-grey-l) + 12%)
	);
	--palette-grey-40: hsl(
		var(--palette-grey-h),
		var(--palette-grey-s),
		calc(var(--palette-grey-l) + 20%)
	);
	--palette-grey-50: hsl(
		var(--palette-grey-h),
		var(--palette-grey-s),
		calc(var(--palette-grey-l) + 32%)
	);
	--palette-grey-60: hsl(
		var(--palette-grey-h),
		var(--palette-grey-s),
		calc(var(--palette-grey-l) + 49%)
	);
	--palette-grey-70: hsl(
		var(--palette-grey-h),
		var(--palette-grey-s),
		calc(var(--palette-grey-l) + 68%)
	);
	--palette-grey-80: hsl(
		var(--palette-grey-h),
		var(--palette-grey-s),
		calc(var(--palette-grey-l) + 74%)
	);
	--palette-grey-90: hsl(
		var(--palette-grey-h),
		var(--palette-grey-s),
		calc(var(--palette-grey-l) + 82%)
	);
	/* #endregion  */

	/* #region green */

	--palette-green-h: 147;
	--palette-green-s: 62%;
	--palette-green-l: 10%;
	--palette-green-a: 100%;

	--palette-green-0: hsl(
		var(--palette-green-h),
		var(--palette-green-s),
		var(--palette-green-l),
		var(--palette-green-a)
	);
	--palette-green-10: hsl(
		var(--palette-green-h),
		var(--palette-green-s),
		calc(var(--palette-green-l) + 3%)
	);
	--palette-green-20: hsl(
		var(--palette-green-h),
		var(--palette-green-s),
		calc(var(--palette-green-l) + 6%)
	);
	--palette-green-30: hsl(
		var(--palette-green-h),
		var(--palette-green-s),
		calc(var(--palette-green-l) + 9%)
	);
	--palette-green-40: hsl(
		var(--palette-green-h),
		var(--palette-green-s),
		calc(var(--palette-green-l) + 12%)
	);
	--palette-green-50: hsl(
		var(--palette-green-h),
		var(--palette-green-s),
		calc(var(--palette-green-l) + 18%)
	);
	--palette-green-60: hsl(
		var(--palette-green-h),
		var(--palette-green-s),
		calc(var(--palette-green-l) + 25%)
	);
	--palette-green-70: hsl(
		var(--palette-green-h),
		var(--palette-green-s),
		calc(var(--palette-green-l) + 60%)
	);
	--palette-green-80: hsl(
		var(--palette-green-h),
		var(--palette-green-s),
		calc(var(--palette-grey-l) + 70%)
	);
	--palette-green-90: hsl(
		var(--palette-green-h),
		var(--palette-green-s),
		calc(var(--palette-grey-l) + 80%)
	);
	/* #endregion  */

	/* #region red */

	--palette-red-h: 360;
	--palette-red-s: 55%;
	--palette-red-l: 7%;

	--palette-red-0: hsl(
		var(--palette-red-h),
		var(--palette-red-s),
		var(--palette-red-l)
	);
	--palette-red-10: hsl(
		var(--palette-red-h),
		var(--palette-red-s),
		calc(var(--palette-red-l) + 3%)
	);
	--palette-red-20: hsl(
		var(--palette-red-h),
		var(--palette-red-s),
		calc(var(--palette-red-l) + 6%)
	);
	--palette-red-30: hsl(
		var(--palette-red-h),
		var(--palette-red-s),
		calc(var(--palette-red-l) + 12%)
	);
	--palette-red-40: hsl(
		var(--palette-red-h),
		var(--palette-red-s),
		calc(var(--palette-red-l) + 25%)
	);
	--palette-red-50: hsl(
		var(--palette-red-h),
		var(--palette-red-s),
		calc(var(--palette-red-l) + 30%)
	);
	--palette-red-60: hsl(
		var(--palette-red-h),
		var(--palette-red-s),
		calc(var(--palette-red-l) + 40%)
	);
	--palette-red-70: hsl(
		var(--palette-red-h),
		calc(var(--palette-red-s) + 32%),
		calc(var(--palette-red-l) + 67%)
	);
	--palette-red-80: hsl(
		var(--palette-red-h),
		var(--palette-red-s),
		calc(var(--palette-red-l) + 75%)
	);
	--palette-red-90: hsl(
		var(--palette-red-h),
		var(--palette-red-s),
		calc(var(--palette-grey-l) + 80%)
	);
	/* #endregion  */

	/* #region blue */

	--palette-blue-h: 220;
	--palette-blue-s: 62%;
	--palette-blue-l: 10%;

	--palette-blue-0: hsl(
		var(--palette-blue-h),
		var(--palette-blue-s),
		var(--palette-blue-l)
	);
	--palette-blue-10: hsl(
		var(--palette-blue-h),
		var(--palette-blue-s),
		calc(var(--palette-blue-l) + 3%)
	);
	--palette-blue-20: hsl(
		var(--palette-blue-h),
		var(--palette-blue-s),
		calc(var(--palette-blue-l) + 6%)
	);
	--palette-blue-30: hsl(
		var(--palette-blue-h),
		var(--palette-blue-s),
		calc(var(--palette-blue-l) + 12%)
	);
	--palette-blue-40: hsl(
		var(--palette-blue-h),
		var(--palette-blue-s),
		calc(var(--palette-blue-l) + 22%)
	);
	--palette-blue-50: hsl(
		var(--palette-blue-h),
		var(--palette-blue-s),
		calc(var(--palette-blue-l) + 30%)
	);
	--palette-blue-60: hsl(
		var(--palette-blue-h),
		var(--palette-blue-s),
		calc(var(--palette-blue-l) + 40%)
	);
	--palette-blue-70: hsl(
		var(--palette-blue-h),
		var(--palette-blue-s),
		calc(var(--palette-blue-l) + 62%)
	);
	--palette-blue-80: hsl(
		var(--palette-blue-h),
		var(--palette-blue-s),
		calc(var(--palette-grey-l) + 70%)
	);
	--palette-blue-90: hsl(
		var(--palette-blue-h),
		var(--palette-blue-s),
		calc(var(--palette-grey-l) + 80%)
	);
	/* #endregion  */

	/* #region purple */

	--palette-purple-h: 275;
	--palette-purple-s: 62%;
	--palette-purple-l: 10%;

	--palette-purple-0: hsl(
		var(--palette-purple-h),
		var(--palette-purple-s),
		var(--palette-purple-l)
	);
	--palette-purple-10: hsl(
		var(--palette-purple-h),
		var(--palette-purple-s),
		calc(var(--palette-purple-l) + 3%)
	);
	--palette-purple-20: hsl(
		var(--palette-purple-h),
		var(--palette-purple-s),
		calc(var(--palette-purple-l) + 6%)
	);
	--palette-purple-30: hsl(
		var(--palette-purple-h),
		var(--palette-purple-s),
		calc(var(--palette-purple-l) + 12%)
	);
	--palette-purple-40: hsl(
		var(--palette-purple-h),
		var(--palette-purple-s),
		calc(var(--palette-purple-l) + 20%)
	);
	--palette-purple-50: hsl(
		var(--palette-purple-h),
		var(--palette-purple-s),
		calc(var(--palette-purple-l) + 30%)
	);
	--palette-purple-60: hsl(
		var(--palette-purple-h),
		var(--palette-purple-s),
		calc(var(--palette-purple-l) + 40%)
	);
	--palette-purple-70: hsl(
		var(--palette-purple-h),
		var(--palette-purple-s),
		calc(var(--palette-purple-l) + 50%)
	);
	--palette-purple-80: hsl(
		var(--palette-purple-h),
		var(--palette-purple-s),
		calc(var(--palette-grey-l) + 70%)
	);
	--palette-purple-90: hsl(
		var(--palette-purple-h),
		var(--palette-purple-s),
		calc(var(--palette-grey-l) + 80%)
	);
	/* #endregion  */

	/* #region orange */

	--palette-orange-h: 24;
	--palette-orange-s: 80%;
	--palette-orange-l: 20%;

	--palette-orange-0: hsl(
		var(--palette-orange-h),
		var(--palette-orange-s),
		var(--palette-orange-l)
	);
	--palette-orange-10: hsl(
		var(--palette-orange-h),
		var(--palette-orange-s),
		calc(var(--palette-orange-l) + 3%)
	);
	--palette-orange-20: hsl(
		var(--palette-orange-h),
		var(--palette-orange-s),
		calc(var(--palette-orange-l) + 6%)
	);
	--palette-orange-30: hsl(
		var(--palette-orange-h),
		var(--palette-orange-s),
		calc(var(--palette-orange-l) + 14%)
	);
	--palette-orange-40: hsl(
		var(--palette-orange-h),
		var(--palette-orange-s),
		calc(var(--palette-orange-l) + 20%)
	);
	--palette-orange-50: hsl(
		var(--palette-orange-h),
		var(--palette-orange-s),
		calc(var(--palette-orange-l) + 30%)
	);
	--palette-orange-60: hsl(
		var(--palette-orange-h),
		var(--palette-orange-s),
		calc(var(--palette-orange-l) + 40%)
	);
	--palette-orange-70: hsl(
		var(--palette-orange-h),
		var(--palette-orange-s),
		calc(var(--palette-orange-l) + 50%)
	);
	--palette-orange-80: hsl(
		var(--palette-orange-h),
		var(--palette-orange-s),
		calc(var(--palette-grey-l) + 70%)
	);
	--palette-orange-90: hsl(
		var(--palette-orange-h),
		var(--palette-orange-s),
		calc(var(--palette-grey-l) + 80%)
	);
	/* #endregion  */

	/* #region teal */

	--palette-teal-h: 182;
	--palette-teal-s: 62%;
	--palette-teal-l: 10%;

	--palette-teal-0: hsl(
		var(--palette-teal-h),
		var(--palette-teal-s),
		var(--palette-teal-l)
	);
	--palette-teal-10: hsl(
		var(--palette-teal-h),
		var(--palette-teal-s),
		calc(var(--palette-teal-l) + 3%)
	);
	--palette-teal-20: hsl(
		var(--palette-teal-h),
		var(--palette-teal-s),
		calc(var(--palette-teal-l) + 6%)
	);
	--palette-teal-30: hsl(
		var(--palette-teal-h),
		var(--palette-teal-s),
		calc(var(--palette-teal-l) + 12%)
	);
	--palette-teal-40: hsl(
		var(--palette-teal-h),
		var(--palette-teal-s),
		calc(var(--palette-teal-l) + 20%)
	);
	--palette-teal-50: hsl(
		var(--palette-teal-h),
		var(--palette-teal-s),
		calc(var(--palette-teal-l) + 30%)
	);
	--palette-teal-60: hsl(
		var(--palette-teal-h),
		var(--palette-teal-s),
		calc(var(--palette-teal-l) + 40%)
	);
	--palette-teal-70: hsl(
		var(--palette-teal-h),
		var(--palette-teal-s),
		calc(var(--palette-teal-l) + 50%)
	);
	--palette-teal-80: hsl(
		var(--palette-teal-h),
		var(--palette-teal-s),
		calc(var(--palette-grey-l) + 70%)
	);
	--palette-teal-90: hsl(
		var(--palette-teal-h),
		var(--palette-teal-s),
		calc(var(--palette-grey-l) + 80%)
	);
	/* #endregion  */

	/* #region pink */

	--palette-pink-h: 324;
	--palette-pink-s: 62%;
	--palette-pink-l: 10%;

	--palette-pink-0: hsl(
		var(--palette-pink-h),
		var(--palette-pink-s),
		var(--palette-pink-l)
	);
	--palette-pink-10: hsl(
		var(--palette-pink-h),
		var(--palette-pink-s),
		calc(var(--palette-pink-l) + 3%)
	);
	--palette-pink-20: hsl(
		var(--palette-pink-h),
		var(--palette-pink-s),
		calc(var(--palette-pink-l) + 6%)
	);
	--palette-pink-30: hsl(
		var(--palette-pink-h),
		var(--palette-pink-s),
		calc(var(--palette-pink-l) + 12%)
	);
	--palette-pink-40: hsl(
		var(--palette-pink-h),
		var(--palette-pink-s),
		calc(var(--palette-pink-l) + 20%)
	);
	--palette-pink-50: hsl(
		var(--palette-pink-h),
		var(--palette-pink-s),
		calc(var(--palette-pink-l) + 30%)
	);
	--palette-pink-60: hsl(
		var(--palette-pink-h),
		var(--palette-pink-s),
		calc(var(--palette-pink-l) + 40%)
	);
	--palette-pink-70: hsl(
		var(--palette-pink-h),
		var(--palette-pink-s),
		calc(var(--palette-pink-l) + 50%)
	);
	--palette-pink-80: hsl(
		var(--palette-pink-h),
		var(--palette-pink-s),
		calc(var(--palette-grey-l) + 70%)
	);
	--palette-pink-90: hsl(
		var(--palette-pink-h),
		var(--palette-pink-s),
		calc(var(--palette-grey-l) + 80%)
	);
	/* #endregion  */

	/* region spruce  */

	--palette-spruce-h: 168;
	--palette-spruce-s: 25%;
	--palette-spruce-l: 10%;

	--palette-spruce-0: hsl(
		var(--palette-spruce-h),
		var(--palette-spruce-s),
		var(--palette-spruce-l)
	);
	--palette-spruce-10: hsl(
		var(--palette-spruce-h),
		var(--palette-spruce-s),
		calc(var(--palette-spruce-l) + 3%)
	);
	--palette-spruce-20: hsl(
		var(--palette-spruce-h),
		var(--palette-spruce-s),
		calc(var(--palette-spruce-l) + 6%)
	);
	--palette-spruce-30: hsl(
		var(--palette-spruce-h),
		var(--palette-spruce-s),
		calc(var(--palette-spruce-l) + 12%)
	);
	--palette-spruce-40: hsl(
		var(--palette-spruce-h),
		var(--palette-spruce-s),
		calc(var(--palette-spruce-l) + 20%)
	);
	--palette-spruce-50: hsl(
		var(--palette-spruce-h),
		var(--palette-spruce-s),
		calc(var(--palette-spruce-l) + 30%)
	);
	--palette-spruce-60: hsl(
		var(--palette-spruce-h),
		var(--palette-spruce-s),
		calc(var(--palette-spruce-l) + 40%)
	);
	--palette-spruce-70: hsl(
		var(--palette-spruce-h),
		calc(var(--palette-spruce-s) * 2),
		calc(var(--palette-spruce-l) + 60%)
	);
	--palette-spruce-80: hsl(
		var(--palette-spruce-h),
		var(--palette-spruce-s),
		calc(var(--palette-spruce-l) + 70%)
	);
	--palette-spruce-90: hsl(
		var(--palette-spruce-h),
		var(--palette-spruce-s),
		calc(var(--palette-spruce-l) + 80%)
	);
	/* #endregion  */

	/* #region custom tag palettes */

	/* emergency */
	--palette-emergency-h: 346;
	--palette-emergency-s: 20%;
	--palette-emergency-l: 10%;

	--palette-emergency-surface: hsl(
		var(--palette-emergency-h),
		var(--palette-emergency-s),
		calc(var(--palette-emergency-l) + 10%)
	);

	--palette-emergency-text: hsl(
		var(--palette-emergency-h),
		calc(var(--palette-emergency-s) + 80%),
		calc(var(--palette-emergency-l) + 62%)
	);

	/* climate */
	--palette-climate-h: 215;
	--palette-climate-s: 37%;
	--palette-climate-l: 10%;

	--palette-climate-surface: hsl(
		var(--palette-climate-h),
		var(--palette-climate-s),
		calc(var(--palette-climate-l) + 10%)
	);

	--palette-climate-text: hsl(
		var(--palette-climate-h),
		calc(var(--palette-climate-s) + 47%),
		calc(var(--palette-climate-l) + 63%)
	);

	/* geopolitical */
	--palette-geopolitical-h: 20;
	--palette-geopolitical-s: 27%;
	--palette-geopolitical-l: 10%;

	--palette-geopolitical-surface: hsl(
		var(--palette-geopolitical-h),
		var(--palette-geopolitical-s),
		calc(var(--palette-geopolitical-l) + 10%)
	);

	--palette-geopolitical-text: hsl(
		var(--palette-geopolitical-h),
		calc(var(--palette-geopolitical-s) + 49%),
		calc(var(--palette-geopolitical-l) + 61%)
	);

	/* infrastructure */
	--palette-infrastructure-h: 255;
	--palette-infrastructure-s: 20%;
	--palette-infrastructure-l: 10%;

	--palette-infrastructure-surface: hsl(
		var(--palette-infrastructure-h),
		var(--palette-infrastructure-s),
		calc(var(--palette-infrastructure-l) + 10%)
	);

	--palette-infrastructure-text: hsl(
		var(--palette-infrastructure-h),
		calc(var(--palette-infrastructure-s) + 40%),
		calc(var(--palette-infrastructure-l) + 66%)
	);

	/* health */
	--palette-health-h: 190;
	--palette-health-s: 20%;
	--palette-health-l: 10%;

	--palette-health-surface: hsl(
		var(--palette-health-h),
		var(--palette-health-s),
		calc(var(--palette-health-l) + 10%)
	);

	--palette-health-text: hsl(
		var(--palette-health-h),
		calc(var(--palette-health-s) + 40%),
		calc(var(--palette-health-l) + 70%)
	);

	/* cyber */
	--palette-cyber-h: 311;
	--palette-cyber-s: 20%;
	--palette-cyber-l: 10%;

	--palette-cyber-surface: hsl(
		var(--palette-cyber-h),
		var(--palette-cyber-s),
		calc(var(--palette-cyber-l) + 10%)
	);

	--palette-cyber-text: hsl(
		var(--palette-cyber-h),
		calc(var(--palette-cyber-s) + 40%),
		calc(var(--palette-cyber-l) + 70%)
	);

	/* cyber */
	--palette-cyber-h: 311;
	--palette-cyber-s: 20%;
	--palette-cyber-l: 10%;

	--palette-cyber-surface: hsl(
		var(--palette-cyber-h),
		var(--palette-cyber-s),
		calc(var(--palette-cyber-l) + 10%)
	);

	--palette-cyber-text: hsl(
		var(--palette-cyber-h),
		calc(var(--palette-cyber-s) + 40%),
		calc(var(--palette-cyber-l) + 70%)
	);

	/* lifecycle */
	--palette-lifecycle-h: 145;
	--palette-lifecycle-s: 25%;
	--palette-lifecycle-l: 10%;

	--palette-lifecycle-surface: hsl(
		var(--palette-lifecycle-h),
		var(--palette-lifecycle-s),
		calc(var(--palette-lifecycle-l) + 10%)
	);

	--palette-lifecycle-text: hsl(
		var(--palette-lifecycle-h),
		calc(var(--palette-lifecycle-s) + 47%),
		calc(var(--palette-lifecycle-l) + 70%)
	);
	/* #endregion  */
}
`, "",{"version":3,"sources":["webpack://./../../packages/design/src/palette.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;;CAElB,oBAAoB;CACpB,qBAAqB;CACrB,qBAAqB;CACrB,oBAAoB;;CAEpB;;;;;EAKC;;CAED,wBAAwB;;CAExB;;;;;EAKC;;CAED;;;;;EAKC;;CAED;;;;;EAKC;CACD;;;;;EAKC;CACD;;;;;EAKC;CACD;;;;;EAKC;CACD;;;;;EAKC;CACD;;;;;EAKC;CACD;;;;;EAKC;CACD;;;;;EAKC;;CAED,eAAe;;CAEf,kBAAkB;;CAElB,oBAAoB;CACpB,qBAAqB;CACrB,uBAAuB;CACvB,oBAAoB;;CAEpB;;;;;EAKC;;CAED,uBAAuB;;CAEvB;;;;;EAKC;;CAED;;;;;EAKC;;CAED;;;;;EAKC;CACD;;;;;EAKC;CACD;;;;;EAKC;CACD;;;;;EAKC;CACD;;;;;EAKC;CACD;;;;;EAKC;CACD;;;;;EAKC;CACD;;;;;EAKC;;CAED,eAAe;;CAEf,iBAAiB;;CAEjB,qBAAqB;CACrB,qBAAqB;CACrB,oBAAoB;CACpB,mBAAmB;;CAEnB;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD,gBAAgB;;CAEhB,kBAAkB;;CAElB,sBAAsB;CACtB,sBAAsB;CACtB,sBAAsB;CACtB,uBAAuB;;CAEvB;;;;;EAKC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD,gBAAgB;;CAEhB,gBAAgB;;CAEhB,oBAAoB;CACpB,oBAAoB;CACpB,mBAAmB;;CAEnB;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD,gBAAgB;;CAEhB,iBAAiB;;CAEjB,qBAAqB;CACrB,qBAAqB;CACrB,qBAAqB;;CAErB;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD,gBAAgB;;CAEhB,mBAAmB;;CAEnB,uBAAuB;CACvB,uBAAuB;CACvB,uBAAuB;;CAEvB;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD,gBAAgB;;CAEhB,mBAAmB;;CAEnB,sBAAsB;CACtB,uBAAuB;CACvB,uBAAuB;;CAEvB;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD,gBAAgB;;CAEhB,iBAAiB;;CAEjB,qBAAqB;CACrB,qBAAqB;CACrB,qBAAqB;;CAErB;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD,gBAAgB;;CAEhB,iBAAiB;;CAEjB,qBAAqB;CACrB,qBAAqB;CACrB,qBAAqB;;CAErB;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD,gBAAgB;;CAEhB,mBAAmB;;CAEnB,uBAAuB;CACvB,uBAAuB;CACvB,uBAAuB;;CAEvB;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD;;;;EAIC;CACD,gBAAgB;;CAEhB,gCAAgC;;CAEhC,cAAc;CACd,0BAA0B;CAC1B,0BAA0B;CAC1B,0BAA0B;;CAE1B;;;;EAIC;;CAED;;;;EAIC;;CAED,YAAY;CACZ,wBAAwB;CACxB,wBAAwB;CACxB,wBAAwB;;CAExB;;;;EAIC;;CAED;;;;EAIC;;CAED,iBAAiB;CACjB,4BAA4B;CAC5B,6BAA6B;CAC7B,6BAA6B;;CAE7B;;;;EAIC;;CAED;;;;EAIC;;CAED,mBAAmB;CACnB,+BAA+B;CAC/B,+BAA+B;CAC/B,+BAA+B;;CAE/B;;;;EAIC;;CAED;;;;EAIC;;CAED,WAAW;CACX,uBAAuB;CACvB,uBAAuB;CACvB,uBAAuB;;CAEvB;;;;EAIC;;CAED;;;;EAIC;;CAED,UAAU;CACV,sBAAsB;CACtB,sBAAsB;CACtB,sBAAsB;;CAEtB;;;;EAIC;;CAED;;;;EAIC;;CAED,UAAU;CACV,sBAAsB;CACtB,sBAAsB;CACtB,sBAAsB;;CAEtB;;;;EAIC;;CAED;;;;EAIC;;CAED,cAAc;CACd,0BAA0B;CAC1B,0BAA0B;CAC1B,0BAA0B;;CAE1B;;;;EAIC;;CAED;;;;EAIC;CACD,gBAAgB;AACjB","sourcesContent":[":root {\n\t/* #region black */\n\n\t--palette-black-h: 0;\n\t--palette-black-s: 0%;\n\t--palette-black-l: 0%;\n\t--palette-black-a: 1;\n\n\t--palette-black-0: hsl(\n\t\tvar(--palette-black-h),\n\t\tvar(--palette-black-s),\n\t\tvar(--palette-black-l),\n\t\tvar(--palette-black-a)\n\t);\n\n\t/* ten shades of black */\n\n\t--palette-black-10: hsla(\n\t\tvar(--palette-black-h),\n\t\tvar(--palette-black-s),\n\t\tvar(--palette-black-l),\n\t\tcalc(var(--palette-black-a) - 0.1)\n\t);\n\n\t--palette-black-20: hsla(\n\t\tvar(--palette-black-h),\n\t\tvar(--palette-black-s),\n\t\tvar(--palette-black-l),\n\t\tcalc(var(--palette-black-a) - 0.2)\n\t);\n\n\t--palette-black-30: hsla(\n\t\tvar(--palette-black-h),\n\t\tvar(--palette-black-s),\n\t\tvar(--palette-black-l),\n\t\tcalc(var(--palette-black-a) - 0.3)\n\t);\n\t--palette-black-40: hsla(\n\t\tvar(--palette-black-h),\n\t\tvar(--palette-black-s),\n\t\tvar(--palette-black-l),\n\t\tcalc(var(--palette-black-a) - 0.4)\n\t);\n\t--palette-black-50: hsla(\n\t\tvar(--palette-black-h),\n\t\tvar(--palette-black-s),\n\t\tvar(--palette-black-l),\n\t\tcalc(var(--palette-black-a) - 0.5)\n\t);\n\t--palette-black-60: hsla(\n\t\tvar(--palette-black-h),\n\t\tvar(--palette-black-s),\n\t\tvar(--palette-black-l),\n\t\tcalc(var(--palette-black-a) - 0.6)\n\t);\n\t--palette-black-70: hsla(\n\t\tvar(--palette-black-h),\n\t\tvar(--palette-black-s),\n\t\tvar(--palette-black-l),\n\t\tcalc(var(--palette-black-a) - 0.7)\n\t);\n\t--palette-black-80: hsla(\n\t\tvar(--palette-black-h),\n\t\tvar(--palette-black-s),\n\t\tvar(--palette-black-l),\n\t\tcalc(var(--palette-black-a) - 0.9)\n\t);\n\t--palette-black-90: hsla(\n\t\tvar(--palette-black-h),\n\t\tvar(--palette-black-s),\n\t\tvar(--palette-black-l),\n\t\tcalc(var(--palette-black-a) - 0.95)\n\t);\n\t--palette-black-100: hsla(\n\t\tvar(--palette-black-h),\n\t\tvar(--palette-black-s),\n\t\tvar(--palette-black-l),\n\t\tcalc(var(--palette-black-a) - 1)\n\t);\n\n\t/* #endregion */\n\n\t/* #region white */\n\n\t--palette-white-h: 0;\n\t--palette-white-s: 0%;\n\t--palette-white-l: 100%;\n\t--palette-white-a: 1;\n\n\t--palette-white-0: hsla(\n\t\tvar(--palette-white-h),\n\t\tvar(--palette-white-s),\n\t\tvar(--palette-white-l),\n\t\tvar(--palette-white-a)\n\t);\n\n\t/*  10 tints of white */\n\n\t--palette-white-10: hsla(\n\t\tvar(--palette-grey-h),\n\t\tvar(--palette-grey-s),\n\t\tvar(--palette-grey-l),\n\t\tcalc(var(--palette-grey-a) - 0.1)\n\t);\n\n\t--palette-white-20: hsla(\n\t\tvar(--palette-grey-h),\n\t\tvar(--palette-grey-s),\n\t\tvar(--palette-grey-l),\n\t\tcalc(var(--palette-grey-a) - 0.2)\n\t);\n\n\t--palette-white-30: hsla(\n\t\tvar(--palette-grey-h),\n\t\tvar(--palette-grey-s),\n\t\tvar(--palette-grey-l),\n\t\tcalc(var(--palette-grey-a) - 0.3)\n\t);\n\t--palette-white-40: hsla(\n\t\tvar(--palette-grey-h),\n\t\tvar(--palette-grey-s),\n\t\tvar(--palette-grey-l),\n\t\tcalc(var(--palette-grey-a) - 0.4)\n\t);\n\t--palette-white-50: hsla(\n\t\tvar(--palette-grey-h),\n\t\tvar(--palette-grey-s),\n\t\tvar(--palette-grey-l),\n\t\tcalc(var(--palette-grey-a) - 0.5)\n\t);\n\t--palette-white-60: hsla(\n\t\tvar(--palette-grey-h),\n\t\tvar(--palette-grey-s),\n\t\tvar(--palette-grey-l),\n\t\tcalc(var(--palette-grey-a) - 0.6)\n\t);\n\t--palette-white-70: hsla(\n\t\tvar(--palette-grey-h),\n\t\tvar(--palette-grey-s),\n\t\tvar(--palette-grey-l),\n\t\tcalc(var(--palette-grey-a) - 0.7)\n\t);\n\t--palette-white-80: hsla(\n\t\tvar(--palette-grey-h),\n\t\tvar(--palette-grey-s),\n\t\tvar(--palette-grey-l),\n\t\tcalc(var(--palette-grey-a) - 0.9)\n\t);\n\t--palette-white-90: hsla(\n\t\tvar(--palette-grey-h),\n\t\tvar(--palette-grey-s),\n\t\tvar(--palette-grey-l),\n\t\tcalc(var(--palette-grey-a) - 0.95)\n\t);\n\t--palette-white-100: hsla(\n\t\tvar(--palette-grey-h),\n\t\tvar(--palette-grey-s),\n\t\tvar(--palette-grey-l),\n\t\tcalc(var(--palette-grey-a) - 1)\n\t);\n\n\t/* #endregion */\n\n\t/* #region grey */\n\n\t--palette-grey-h: 210;\n\t--palette-grey-s: 20%;\n\t--palette-grey-l: 8%;\n\t--palette-grey-a: 1;\n\n\t--palette-grey-0: hsl(\n\t\tvar(--palette-grey-h),\n\t\tvar(--palette-grey-s),\n\t\tvar(--palette-grey-l)\n\t);\n\t--palette-grey-10: hsl(\n\t\tvar(--palette-grey-h),\n\t\tvar(--palette-grey-s),\n\t\tcalc(var(--palette-grey-l) + 4%)\n\t);\n\t--palette-grey-20: hsl(\n\t\tvar(--palette-grey-h),\n\t\tvar(--palette-grey-s),\n\t\tcalc(var(--palette-grey-l) + 8%)\n\t);\n\t--palette-grey-30: hsl(\n\t\tvar(--palette-grey-h),\n\t\tvar(--palette-grey-s),\n\t\tcalc(var(--palette-grey-l) + 12%)\n\t);\n\t--palette-grey-40: hsl(\n\t\tvar(--palette-grey-h),\n\t\tvar(--palette-grey-s),\n\t\tcalc(var(--palette-grey-l) + 20%)\n\t);\n\t--palette-grey-50: hsl(\n\t\tvar(--palette-grey-h),\n\t\tvar(--palette-grey-s),\n\t\tcalc(var(--palette-grey-l) + 32%)\n\t);\n\t--palette-grey-60: hsl(\n\t\tvar(--palette-grey-h),\n\t\tvar(--palette-grey-s),\n\t\tcalc(var(--palette-grey-l) + 49%)\n\t);\n\t--palette-grey-70: hsl(\n\t\tvar(--palette-grey-h),\n\t\tvar(--palette-grey-s),\n\t\tcalc(var(--palette-grey-l) + 68%)\n\t);\n\t--palette-grey-80: hsl(\n\t\tvar(--palette-grey-h),\n\t\tvar(--palette-grey-s),\n\t\tcalc(var(--palette-grey-l) + 74%)\n\t);\n\t--palette-grey-90: hsl(\n\t\tvar(--palette-grey-h),\n\t\tvar(--palette-grey-s),\n\t\tcalc(var(--palette-grey-l) + 82%)\n\t);\n\t/* #endregion  */\n\n\t/* #region green */\n\n\t--palette-green-h: 147;\n\t--palette-green-s: 62%;\n\t--palette-green-l: 10%;\n\t--palette-green-a: 100%;\n\n\t--palette-green-0: hsl(\n\t\tvar(--palette-green-h),\n\t\tvar(--palette-green-s),\n\t\tvar(--palette-green-l),\n\t\tvar(--palette-green-a)\n\t);\n\t--palette-green-10: hsl(\n\t\tvar(--palette-green-h),\n\t\tvar(--palette-green-s),\n\t\tcalc(var(--palette-green-l) + 3%)\n\t);\n\t--palette-green-20: hsl(\n\t\tvar(--palette-green-h),\n\t\tvar(--palette-green-s),\n\t\tcalc(var(--palette-green-l) + 6%)\n\t);\n\t--palette-green-30: hsl(\n\t\tvar(--palette-green-h),\n\t\tvar(--palette-green-s),\n\t\tcalc(var(--palette-green-l) + 9%)\n\t);\n\t--palette-green-40: hsl(\n\t\tvar(--palette-green-h),\n\t\tvar(--palette-green-s),\n\t\tcalc(var(--palette-green-l) + 12%)\n\t);\n\t--palette-green-50: hsl(\n\t\tvar(--palette-green-h),\n\t\tvar(--palette-green-s),\n\t\tcalc(var(--palette-green-l) + 18%)\n\t);\n\t--palette-green-60: hsl(\n\t\tvar(--palette-green-h),\n\t\tvar(--palette-green-s),\n\t\tcalc(var(--palette-green-l) + 25%)\n\t);\n\t--palette-green-70: hsl(\n\t\tvar(--palette-green-h),\n\t\tvar(--palette-green-s),\n\t\tcalc(var(--palette-green-l) + 60%)\n\t);\n\t--palette-green-80: hsl(\n\t\tvar(--palette-green-h),\n\t\tvar(--palette-green-s),\n\t\tcalc(var(--palette-grey-l) + 70%)\n\t);\n\t--palette-green-90: hsl(\n\t\tvar(--palette-green-h),\n\t\tvar(--palette-green-s),\n\t\tcalc(var(--palette-grey-l) + 80%)\n\t);\n\t/* #endregion  */\n\n\t/* #region red */\n\n\t--palette-red-h: 360;\n\t--palette-red-s: 55%;\n\t--palette-red-l: 7%;\n\n\t--palette-red-0: hsl(\n\t\tvar(--palette-red-h),\n\t\tvar(--palette-red-s),\n\t\tvar(--palette-red-l)\n\t);\n\t--palette-red-10: hsl(\n\t\tvar(--palette-red-h),\n\t\tvar(--palette-red-s),\n\t\tcalc(var(--palette-red-l) + 3%)\n\t);\n\t--palette-red-20: hsl(\n\t\tvar(--palette-red-h),\n\t\tvar(--palette-red-s),\n\t\tcalc(var(--palette-red-l) + 6%)\n\t);\n\t--palette-red-30: hsl(\n\t\tvar(--palette-red-h),\n\t\tvar(--palette-red-s),\n\t\tcalc(var(--palette-red-l) + 12%)\n\t);\n\t--palette-red-40: hsl(\n\t\tvar(--palette-red-h),\n\t\tvar(--palette-red-s),\n\t\tcalc(var(--palette-red-l) + 25%)\n\t);\n\t--palette-red-50: hsl(\n\t\tvar(--palette-red-h),\n\t\tvar(--palette-red-s),\n\t\tcalc(var(--palette-red-l) + 30%)\n\t);\n\t--palette-red-60: hsl(\n\t\tvar(--palette-red-h),\n\t\tvar(--palette-red-s),\n\t\tcalc(var(--palette-red-l) + 40%)\n\t);\n\t--palette-red-70: hsl(\n\t\tvar(--palette-red-h),\n\t\tcalc(var(--palette-red-s) + 32%),\n\t\tcalc(var(--palette-red-l) + 67%)\n\t);\n\t--palette-red-80: hsl(\n\t\tvar(--palette-red-h),\n\t\tvar(--palette-red-s),\n\t\tcalc(var(--palette-red-l) + 75%)\n\t);\n\t--palette-red-90: hsl(\n\t\tvar(--palette-red-h),\n\t\tvar(--palette-red-s),\n\t\tcalc(var(--palette-grey-l) + 80%)\n\t);\n\t/* #endregion  */\n\n\t/* #region blue */\n\n\t--palette-blue-h: 220;\n\t--palette-blue-s: 62%;\n\t--palette-blue-l: 10%;\n\n\t--palette-blue-0: hsl(\n\t\tvar(--palette-blue-h),\n\t\tvar(--palette-blue-s),\n\t\tvar(--palette-blue-l)\n\t);\n\t--palette-blue-10: hsl(\n\t\tvar(--palette-blue-h),\n\t\tvar(--palette-blue-s),\n\t\tcalc(var(--palette-blue-l) + 3%)\n\t);\n\t--palette-blue-20: hsl(\n\t\tvar(--palette-blue-h),\n\t\tvar(--palette-blue-s),\n\t\tcalc(var(--palette-blue-l) + 6%)\n\t);\n\t--palette-blue-30: hsl(\n\t\tvar(--palette-blue-h),\n\t\tvar(--palette-blue-s),\n\t\tcalc(var(--palette-blue-l) + 12%)\n\t);\n\t--palette-blue-40: hsl(\n\t\tvar(--palette-blue-h),\n\t\tvar(--palette-blue-s),\n\t\tcalc(var(--palette-blue-l) + 22%)\n\t);\n\t--palette-blue-50: hsl(\n\t\tvar(--palette-blue-h),\n\t\tvar(--palette-blue-s),\n\t\tcalc(var(--palette-blue-l) + 30%)\n\t);\n\t--palette-blue-60: hsl(\n\t\tvar(--palette-blue-h),\n\t\tvar(--palette-blue-s),\n\t\tcalc(var(--palette-blue-l) + 40%)\n\t);\n\t--palette-blue-70: hsl(\n\t\tvar(--palette-blue-h),\n\t\tvar(--palette-blue-s),\n\t\tcalc(var(--palette-blue-l) + 62%)\n\t);\n\t--palette-blue-80: hsl(\n\t\tvar(--palette-blue-h),\n\t\tvar(--palette-blue-s),\n\t\tcalc(var(--palette-grey-l) + 70%)\n\t);\n\t--palette-blue-90: hsl(\n\t\tvar(--palette-blue-h),\n\t\tvar(--palette-blue-s),\n\t\tcalc(var(--palette-grey-l) + 80%)\n\t);\n\t/* #endregion  */\n\n\t/* #region purple */\n\n\t--palette-purple-h: 275;\n\t--palette-purple-s: 62%;\n\t--palette-purple-l: 10%;\n\n\t--palette-purple-0: hsl(\n\t\tvar(--palette-purple-h),\n\t\tvar(--palette-purple-s),\n\t\tvar(--palette-purple-l)\n\t);\n\t--palette-purple-10: hsl(\n\t\tvar(--palette-purple-h),\n\t\tvar(--palette-purple-s),\n\t\tcalc(var(--palette-purple-l) + 3%)\n\t);\n\t--palette-purple-20: hsl(\n\t\tvar(--palette-purple-h),\n\t\tvar(--palette-purple-s),\n\t\tcalc(var(--palette-purple-l) + 6%)\n\t);\n\t--palette-purple-30: hsl(\n\t\tvar(--palette-purple-h),\n\t\tvar(--palette-purple-s),\n\t\tcalc(var(--palette-purple-l) + 12%)\n\t);\n\t--palette-purple-40: hsl(\n\t\tvar(--palette-purple-h),\n\t\tvar(--palette-purple-s),\n\t\tcalc(var(--palette-purple-l) + 20%)\n\t);\n\t--palette-purple-50: hsl(\n\t\tvar(--palette-purple-h),\n\t\tvar(--palette-purple-s),\n\t\tcalc(var(--palette-purple-l) + 30%)\n\t);\n\t--palette-purple-60: hsl(\n\t\tvar(--palette-purple-h),\n\t\tvar(--palette-purple-s),\n\t\tcalc(var(--palette-purple-l) + 40%)\n\t);\n\t--palette-purple-70: hsl(\n\t\tvar(--palette-purple-h),\n\t\tvar(--palette-purple-s),\n\t\tcalc(var(--palette-purple-l) + 50%)\n\t);\n\t--palette-purple-80: hsl(\n\t\tvar(--palette-purple-h),\n\t\tvar(--palette-purple-s),\n\t\tcalc(var(--palette-grey-l) + 70%)\n\t);\n\t--palette-purple-90: hsl(\n\t\tvar(--palette-purple-h),\n\t\tvar(--palette-purple-s),\n\t\tcalc(var(--palette-grey-l) + 80%)\n\t);\n\t/* #endregion  */\n\n\t/* #region orange */\n\n\t--palette-orange-h: 24;\n\t--palette-orange-s: 80%;\n\t--palette-orange-l: 20%;\n\n\t--palette-orange-0: hsl(\n\t\tvar(--palette-orange-h),\n\t\tvar(--palette-orange-s),\n\t\tvar(--palette-orange-l)\n\t);\n\t--palette-orange-10: hsl(\n\t\tvar(--palette-orange-h),\n\t\tvar(--palette-orange-s),\n\t\tcalc(var(--palette-orange-l) + 3%)\n\t);\n\t--palette-orange-20: hsl(\n\t\tvar(--palette-orange-h),\n\t\tvar(--palette-orange-s),\n\t\tcalc(var(--palette-orange-l) + 6%)\n\t);\n\t--palette-orange-30: hsl(\n\t\tvar(--palette-orange-h),\n\t\tvar(--palette-orange-s),\n\t\tcalc(var(--palette-orange-l) + 14%)\n\t);\n\t--palette-orange-40: hsl(\n\t\tvar(--palette-orange-h),\n\t\tvar(--palette-orange-s),\n\t\tcalc(var(--palette-orange-l) + 20%)\n\t);\n\t--palette-orange-50: hsl(\n\t\tvar(--palette-orange-h),\n\t\tvar(--palette-orange-s),\n\t\tcalc(var(--palette-orange-l) + 30%)\n\t);\n\t--palette-orange-60: hsl(\n\t\tvar(--palette-orange-h),\n\t\tvar(--palette-orange-s),\n\t\tcalc(var(--palette-orange-l) + 40%)\n\t);\n\t--palette-orange-70: hsl(\n\t\tvar(--palette-orange-h),\n\t\tvar(--palette-orange-s),\n\t\tcalc(var(--palette-orange-l) + 50%)\n\t);\n\t--palette-orange-80: hsl(\n\t\tvar(--palette-orange-h),\n\t\tvar(--palette-orange-s),\n\t\tcalc(var(--palette-grey-l) + 70%)\n\t);\n\t--palette-orange-90: hsl(\n\t\tvar(--palette-orange-h),\n\t\tvar(--palette-orange-s),\n\t\tcalc(var(--palette-grey-l) + 80%)\n\t);\n\t/* #endregion  */\n\n\t/* #region teal */\n\n\t--palette-teal-h: 182;\n\t--palette-teal-s: 62%;\n\t--palette-teal-l: 10%;\n\n\t--palette-teal-0: hsl(\n\t\tvar(--palette-teal-h),\n\t\tvar(--palette-teal-s),\n\t\tvar(--palette-teal-l)\n\t);\n\t--palette-teal-10: hsl(\n\t\tvar(--palette-teal-h),\n\t\tvar(--palette-teal-s),\n\t\tcalc(var(--palette-teal-l) + 3%)\n\t);\n\t--palette-teal-20: hsl(\n\t\tvar(--palette-teal-h),\n\t\tvar(--palette-teal-s),\n\t\tcalc(var(--palette-teal-l) + 6%)\n\t);\n\t--palette-teal-30: hsl(\n\t\tvar(--palette-teal-h),\n\t\tvar(--palette-teal-s),\n\t\tcalc(var(--palette-teal-l) + 12%)\n\t);\n\t--palette-teal-40: hsl(\n\t\tvar(--palette-teal-h),\n\t\tvar(--palette-teal-s),\n\t\tcalc(var(--palette-teal-l) + 20%)\n\t);\n\t--palette-teal-50: hsl(\n\t\tvar(--palette-teal-h),\n\t\tvar(--palette-teal-s),\n\t\tcalc(var(--palette-teal-l) + 30%)\n\t);\n\t--palette-teal-60: hsl(\n\t\tvar(--palette-teal-h),\n\t\tvar(--palette-teal-s),\n\t\tcalc(var(--palette-teal-l) + 40%)\n\t);\n\t--palette-teal-70: hsl(\n\t\tvar(--palette-teal-h),\n\t\tvar(--palette-teal-s),\n\t\tcalc(var(--palette-teal-l) + 50%)\n\t);\n\t--palette-teal-80: hsl(\n\t\tvar(--palette-teal-h),\n\t\tvar(--palette-teal-s),\n\t\tcalc(var(--palette-grey-l) + 70%)\n\t);\n\t--palette-teal-90: hsl(\n\t\tvar(--palette-teal-h),\n\t\tvar(--palette-teal-s),\n\t\tcalc(var(--palette-grey-l) + 80%)\n\t);\n\t/* #endregion  */\n\n\t/* #region pink */\n\n\t--palette-pink-h: 324;\n\t--palette-pink-s: 62%;\n\t--palette-pink-l: 10%;\n\n\t--palette-pink-0: hsl(\n\t\tvar(--palette-pink-h),\n\t\tvar(--palette-pink-s),\n\t\tvar(--palette-pink-l)\n\t);\n\t--palette-pink-10: hsl(\n\t\tvar(--palette-pink-h),\n\t\tvar(--palette-pink-s),\n\t\tcalc(var(--palette-pink-l) + 3%)\n\t);\n\t--palette-pink-20: hsl(\n\t\tvar(--palette-pink-h),\n\t\tvar(--palette-pink-s),\n\t\tcalc(var(--palette-pink-l) + 6%)\n\t);\n\t--palette-pink-30: hsl(\n\t\tvar(--palette-pink-h),\n\t\tvar(--palette-pink-s),\n\t\tcalc(var(--palette-pink-l) + 12%)\n\t);\n\t--palette-pink-40: hsl(\n\t\tvar(--palette-pink-h),\n\t\tvar(--palette-pink-s),\n\t\tcalc(var(--palette-pink-l) + 20%)\n\t);\n\t--palette-pink-50: hsl(\n\t\tvar(--palette-pink-h),\n\t\tvar(--palette-pink-s),\n\t\tcalc(var(--palette-pink-l) + 30%)\n\t);\n\t--palette-pink-60: hsl(\n\t\tvar(--palette-pink-h),\n\t\tvar(--palette-pink-s),\n\t\tcalc(var(--palette-pink-l) + 40%)\n\t);\n\t--palette-pink-70: hsl(\n\t\tvar(--palette-pink-h),\n\t\tvar(--palette-pink-s),\n\t\tcalc(var(--palette-pink-l) + 50%)\n\t);\n\t--palette-pink-80: hsl(\n\t\tvar(--palette-pink-h),\n\t\tvar(--palette-pink-s),\n\t\tcalc(var(--palette-grey-l) + 70%)\n\t);\n\t--palette-pink-90: hsl(\n\t\tvar(--palette-pink-h),\n\t\tvar(--palette-pink-s),\n\t\tcalc(var(--palette-grey-l) + 80%)\n\t);\n\t/* #endregion  */\n\n\t/* region spruce  */\n\n\t--palette-spruce-h: 168;\n\t--palette-spruce-s: 25%;\n\t--palette-spruce-l: 10%;\n\n\t--palette-spruce-0: hsl(\n\t\tvar(--palette-spruce-h),\n\t\tvar(--palette-spruce-s),\n\t\tvar(--palette-spruce-l)\n\t);\n\t--palette-spruce-10: hsl(\n\t\tvar(--palette-spruce-h),\n\t\tvar(--palette-spruce-s),\n\t\tcalc(var(--palette-spruce-l) + 3%)\n\t);\n\t--palette-spruce-20: hsl(\n\t\tvar(--palette-spruce-h),\n\t\tvar(--palette-spruce-s),\n\t\tcalc(var(--palette-spruce-l) + 6%)\n\t);\n\t--palette-spruce-30: hsl(\n\t\tvar(--palette-spruce-h),\n\t\tvar(--palette-spruce-s),\n\t\tcalc(var(--palette-spruce-l) + 12%)\n\t);\n\t--palette-spruce-40: hsl(\n\t\tvar(--palette-spruce-h),\n\t\tvar(--palette-spruce-s),\n\t\tcalc(var(--palette-spruce-l) + 20%)\n\t);\n\t--palette-spruce-50: hsl(\n\t\tvar(--palette-spruce-h),\n\t\tvar(--palette-spruce-s),\n\t\tcalc(var(--palette-spruce-l) + 30%)\n\t);\n\t--palette-spruce-60: hsl(\n\t\tvar(--palette-spruce-h),\n\t\tvar(--palette-spruce-s),\n\t\tcalc(var(--palette-spruce-l) + 40%)\n\t);\n\t--palette-spruce-70: hsl(\n\t\tvar(--palette-spruce-h),\n\t\tcalc(var(--palette-spruce-s) * 2),\n\t\tcalc(var(--palette-spruce-l) + 60%)\n\t);\n\t--palette-spruce-80: hsl(\n\t\tvar(--palette-spruce-h),\n\t\tvar(--palette-spruce-s),\n\t\tcalc(var(--palette-spruce-l) + 70%)\n\t);\n\t--palette-spruce-90: hsl(\n\t\tvar(--palette-spruce-h),\n\t\tvar(--palette-spruce-s),\n\t\tcalc(var(--palette-spruce-l) + 80%)\n\t);\n\t/* #endregion  */\n\n\t/* #region custom tag palettes */\n\n\t/* emergency */\n\t--palette-emergency-h: 346;\n\t--palette-emergency-s: 20%;\n\t--palette-emergency-l: 10%;\n\n\t--palette-emergency-surface: hsl(\n\t\tvar(--palette-emergency-h),\n\t\tvar(--palette-emergency-s),\n\t\tcalc(var(--palette-emergency-l) + 10%)\n\t);\n\n\t--palette-emergency-text: hsl(\n\t\tvar(--palette-emergency-h),\n\t\tcalc(var(--palette-emergency-s) + 80%),\n\t\tcalc(var(--palette-emergency-l) + 62%)\n\t);\n\n\t/* climate */\n\t--palette-climate-h: 215;\n\t--palette-climate-s: 37%;\n\t--palette-climate-l: 10%;\n\n\t--palette-climate-surface: hsl(\n\t\tvar(--palette-climate-h),\n\t\tvar(--palette-climate-s),\n\t\tcalc(var(--palette-climate-l) + 10%)\n\t);\n\n\t--palette-climate-text: hsl(\n\t\tvar(--palette-climate-h),\n\t\tcalc(var(--palette-climate-s) + 47%),\n\t\tcalc(var(--palette-climate-l) + 63%)\n\t);\n\n\t/* geopolitical */\n\t--palette-geopolitical-h: 20;\n\t--palette-geopolitical-s: 27%;\n\t--palette-geopolitical-l: 10%;\n\n\t--palette-geopolitical-surface: hsl(\n\t\tvar(--palette-geopolitical-h),\n\t\tvar(--palette-geopolitical-s),\n\t\tcalc(var(--palette-geopolitical-l) + 10%)\n\t);\n\n\t--palette-geopolitical-text: hsl(\n\t\tvar(--palette-geopolitical-h),\n\t\tcalc(var(--palette-geopolitical-s) + 49%),\n\t\tcalc(var(--palette-geopolitical-l) + 61%)\n\t);\n\n\t/* infrastructure */\n\t--palette-infrastructure-h: 255;\n\t--palette-infrastructure-s: 20%;\n\t--palette-infrastructure-l: 10%;\n\n\t--palette-infrastructure-surface: hsl(\n\t\tvar(--palette-infrastructure-h),\n\t\tvar(--palette-infrastructure-s),\n\t\tcalc(var(--palette-infrastructure-l) + 10%)\n\t);\n\n\t--palette-infrastructure-text: hsl(\n\t\tvar(--palette-infrastructure-h),\n\t\tcalc(var(--palette-infrastructure-s) + 40%),\n\t\tcalc(var(--palette-infrastructure-l) + 66%)\n\t);\n\n\t/* health */\n\t--palette-health-h: 190;\n\t--palette-health-s: 20%;\n\t--palette-health-l: 10%;\n\n\t--palette-health-surface: hsl(\n\t\tvar(--palette-health-h),\n\t\tvar(--palette-health-s),\n\t\tcalc(var(--palette-health-l) + 10%)\n\t);\n\n\t--palette-health-text: hsl(\n\t\tvar(--palette-health-h),\n\t\tcalc(var(--palette-health-s) + 40%),\n\t\tcalc(var(--palette-health-l) + 70%)\n\t);\n\n\t/* cyber */\n\t--palette-cyber-h: 311;\n\t--palette-cyber-s: 20%;\n\t--palette-cyber-l: 10%;\n\n\t--palette-cyber-surface: hsl(\n\t\tvar(--palette-cyber-h),\n\t\tvar(--palette-cyber-s),\n\t\tcalc(var(--palette-cyber-l) + 10%)\n\t);\n\n\t--palette-cyber-text: hsl(\n\t\tvar(--palette-cyber-h),\n\t\tcalc(var(--palette-cyber-s) + 40%),\n\t\tcalc(var(--palette-cyber-l) + 70%)\n\t);\n\n\t/* cyber */\n\t--palette-cyber-h: 311;\n\t--palette-cyber-s: 20%;\n\t--palette-cyber-l: 10%;\n\n\t--palette-cyber-surface: hsl(\n\t\tvar(--palette-cyber-h),\n\t\tvar(--palette-cyber-s),\n\t\tcalc(var(--palette-cyber-l) + 10%)\n\t);\n\n\t--palette-cyber-text: hsl(\n\t\tvar(--palette-cyber-h),\n\t\tcalc(var(--palette-cyber-s) + 40%),\n\t\tcalc(var(--palette-cyber-l) + 70%)\n\t);\n\n\t/* lifecycle */\n\t--palette-lifecycle-h: 145;\n\t--palette-lifecycle-s: 25%;\n\t--palette-lifecycle-l: 10%;\n\n\t--palette-lifecycle-surface: hsl(\n\t\tvar(--palette-lifecycle-h),\n\t\tvar(--palette-lifecycle-s),\n\t\tcalc(var(--palette-lifecycle-l) + 10%)\n\t);\n\n\t--palette-lifecycle-text: hsl(\n\t\tvar(--palette-lifecycle-h),\n\t\tcalc(var(--palette-lifecycle-s) + 47%),\n\t\tcalc(var(--palette-lifecycle-l) + 70%)\n\t);\n\t/* #endregion  */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
